import { useContext } from "react"
import { AppContext } from "../App"
import { CDN_URL, formatMoney } from "../Helpers"

export default function ContentCard({ data, type, viewer }) {

  const appContext = useContext(AppContext);
  function view() {
    appContext.navTo({
      item: 'view',
      subItem: viewer,
      extraItem: data.uuid,
    })
  }

  return (
    <div className="card marketplace-card h-100" onClick={view}>
      <div className="marketplace-card-cover">
        <img src={CDN_URL + data.coverPhoto} alt={data.title} />
        <span className="marketplace-type-badge">{type}</span>
      </div>

      <div className="card-body d-flex flex-column">
        <h6 className="marketplace-card-title">{data.title}</h6>
        <div className="mt-auto d-flex justify-content-between align-items-center gap-3">
          <h6 className="marketplace-price m-0">TZS {formatMoney(data.price)}</h6>
          <button className="btn btn-sm btn-primary btn-rounded">View</button>
        </div>
      </div>
    </div>
  )
}
